import React, { useState, useEffect } from "react";
import "./WhyPublish.css";
import { BsFileEarmarkPdfFill } from "react-icons/bs";

const WhyPublish = () => {
    const [showScroll, setShowScroll] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowScroll(true);
            } else {
                setShowScroll(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div>
            {/* Why Publish Section */}
            <div className="container py-5">
                <h2 className="fw-bold">WHY PUBLISHED WITH RESEARCH DISCOURSE</h2>
                <hr className="border-danger w-25" />
                <div className="row">
                    <div className="col-md-6 d-flex align-items-start">
                        <i className="text-warning fs-3 me-2"><BsFileEarmarkPdfFill /></i>
                        <p><strong>NAME OF JOURNAL:</strong> Research Discourse: An International Peer-Reviewed Refereed Research Journal, ISSN 2277-2014 (Print)</p>
                    </div>
                    <div className="col-md-6 d-flex align-items-start">
                        <i className="text-warning fs-3 me-2 "><BsFileEarmarkPdfFill /></i>
                        <p><strong>LANGUAGE:</strong> English / Hindi</p>
                    </div>
                    <div className="col-md-6 d-flex align-items-start">
                        <i className="text-warning fs-3 me-2"><BsFileEarmarkPdfFill /></i>
                        <p><strong>Broad Subject Category:</strong> Social Sciences</p>
                    </div>
                    <div className="col-md-6 d-flex align-items-start">
                        <i className="text-warning fs-3 me-2"><BsFileEarmarkPdfFill /></i>
                        <p><strong>LAUNCH DATE:</strong> 04/01/2012</p>
                    </div>
                    <div className="col-md-6 d-flex align-items-start">
                        <i className="text-warning fs-3 me-2"><BsFileEarmarkPdfFill /></i>
                        <p><strong>FREQUENCY:</strong> Quarterly</p>
                    </div>
                </div>
            </div>

            {/* Scroll to Top Button */}
            {showScroll && (
                <button className="scroll-to-top bg-warning" onClick={scrollToTop}>
                    &#8593;
                </button>
            )}
        </div>
    );
};

export default WhyPublish;
